import AboutDetails from "../components/AboutDetails";

export default function AboutPage() {
  return (
    <div className="page">
      <header className="page__hero">
        <h1>About Mokorotlo College</h1>
        <p>
          Explore our background, vision, mission, and the values that power every program at Mokorotlo College of Creative Technology.
        </p>
      </header>

      <AboutDetails />
    </div>
  );
}
